import { CustomerTemplate, FieldError, FieldInfo, SignatureInfo } from "../../../src/types";
import { languages, checkLineCount, combineErrors, signatureInfo, size, getContentField } from "./shared";

const easterText = '„Frühling wird es weit und breit und die Häschen stehen bereit. Sie bringen dir zur Osterfeier, viele bunt bemalte Eier.“'


export const easterTemplateData: CustomerTemplate = {
    key: 'easter',
        name: {
            de: 'Osterkarte',
            en: 'Easter card'
        },
        ...size,
        languages,
        signatureInfo,
        templateData: [
            {
                key: 'headlineTop',
                name: {
                    en: 'Headline Top',
                    de: 'Überschrift obere Zeile'
                },
                languageData: {
                    'de': 'Frohe Ostern',
                    'en': 'Happy easter'
                },
                maxLength: 20,
                hide: false,
                isValid: combineErrors([checkLineCount(1)])
            },
            getContentField(easterText)
        ],
        font: {
            headlineTop: {
                family: 'Cookie-Regular',
                color: '#000', 
                size: 55,
                TopPadding: 320,
                lineHeight: 20
            },
            doubleHeadline: false,
            content: {
                family: 'Roboto-Light',
                color: '#000', 
                size: 16,
                TopPadding: 384,
                lineHeight: 20
            },
        },
        signature: {
            topPadding: 370,
            contentDep: true,
            singleSignature: false,
            fontSize: 30,
            fontSizeSub: 10,
            color: '#000'
        }
}